module.exports = __webpack_public_path__ + "static/img/foot-logo1.69c89f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foot-logo1.png
// module id = pP77
// module chunks = 5